import { render, staticRenderFns } from "./ListAprovals.vue?vue&type=template&id=6c1cbbf8&"
import script from "./ListAprovals.vue?vue&type=script&lang=js&"
export * from "./ListAprovals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c1cbbf8')) {
      api.createRecord('6c1cbbf8', component.options)
    } else {
      api.reload('6c1cbbf8', component.options)
    }
    module.hot.accept("./ListAprovals.vue?vue&type=template&id=6c1cbbf8&", function () {
      api.rerender('6c1cbbf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListAprovals.vue"
export default component.exports